define('StoreLocator.EntryPoint',
	[
		'StoreLocator.List.All.Store.View',
		'underscore'
	],
	function (
		StoreLocatorListAllView,
		_
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				_.extend(StoreLocatorListAllView.prototype, {
					getContext: _.wrap(StoreLocatorListAllView.prototype.getContext, function(fn, e) { 
						var context = fn.apply(this, _.toArray(arguments).slice(1));
						context.storeImage = this.model.get('storeImage');
						return context;
					})
				})
			}
		};
	});
